import React from 'react';
import TruncateItemWithTooltip from 'helpers/truncateItemWithTooltip';
import { makeStyles } from '@material-ui/core';
import { transparentize } from 'polished';
import { Theme } from 'styles/ThemeTyping';

interface Props {
  label: string;
  className?: string;
  truncationDisabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

function Chip({ label, className, truncationDisabled, onClick }: Props) {
  const classes = useStyles();

  if (truncationDisabled) {
    return (
      <div className={className ? className : classes.root} onClick={onClick}>
        {label}
      </div>
    );
  }

  return (
    <div className={className ? className : classes.root} onClick={onClick}>
      <TruncateItemWithTooltip option={label} />
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderRadius: 4,
    backgroundColor: transparentize(0.96, theme.palette.secondary.main),
    color: theme.palette.secondary.main,
    maxHeight: 20,
    maxWidth: 120,
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    marginRight: theme.spacing(0.5),
  },
}));

export default Chip;
